import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
var Suggestions = /*#__PURE__*/function (_React$Component) {
  _inherits(Suggestions, _React$Component);
  var _super = _createSuper(Suggestions);
  function Suggestions(props) {
    var _this;
    _classCallCheck(this, Suggestions);
    _this = _super.call(this, props);
    _this.bindings = {
      onMouseLeave: _this.onMouseLeave.bind(_assertThisInitialized(_this))
    };
    return _this;
  }
  _createClass(Suggestions, [{
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.props.onMouseLeave(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _a;
      if (!((_a = this.props.children) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
      }
      return /*#__PURE__*/React.createElement("ul", {
        role: "listbox",
        hidden: !this.props.visible,
        onMouseLeave: this.bindings.onMouseLeave
      }, this.props.children);
    }
  }]);
  return Suggestions;
}(React.Component);
Suggestions.defaultProps = {
  children: []
};
export default Suggestions;